import ProductCard from '../ProductCard/ProductCard';
import './FeaturedProducts.css';
import Button from '../Button/Button';
import React, { useState, useEffect } from 'react';
import { neo4jService } from '../../services/neo4jService';

const FeaturedProducts = () => {
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState(['All']);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadFeaturedProducts();
  }, []);

  const loadFeaturedProducts = async () => {
    try {
      setLoading(true);
      const featuredProducts = await neo4jService.getFeaturedProducts();
      // console.log('Featured products:', featuredProducts); // Debug log
      setProducts(featuredProducts);
      
      // Extract unique categories from featured products
      const uniqueCategories = ['All', ...new Set(featuredProducts
        .map(product => product.category)
        .filter(category => category)) // Filter out null/undefined
      ];
      // console.log('Unique categories:', uniqueCategories); // Debug log
      setCategories(uniqueCategories);
      
      setError(null);
    } catch (err) {
      console.error('Error loading featured products:', err);
      setError('Failed to load featured products');
    } finally {
      setLoading(false);
    }
  };

  // Filter the products based on the selected filter
  const filteredProducts = selectedFilter === 'All' 
    ? products 
    : products.filter(product => product.category === selectedFilter);

  if (loading) {
    return <div className="loading">Loading featured products...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!products || products.length === 0) {
    return (
      <div className="products-section">
        <h2 className="section-title">Featured Products</h2>
        <div className="no-products">No featured products available.</div>
      </div>
    );
  }

  return (
    <div className="products-section">
      <div className="products-header">
        <h2 className="section-title">Featured Products</h2>
        <div className="category-filters">
          {categories.map((filter) => (
            <Button
              key={filter}
              className={`filter-button ${selectedFilter === filter ? 'active' : ''}`}
              onClick={() => setSelectedFilter(filter)}
            >
              {filter}
            </Button>
          ))}
        </div>
      </div>
      
      <div className="products-grid">
        {filteredProducts.map((product) => (
          <ProductCard
            key={product.id}
            id={product.id}
            name={product.name}
            price={product.price}
            brand={product.brand}
            condition={product.condition}
            description={product.description}
            image={product.main_image}
            rating={product.rating}
            reviewsCount={product.reviewsCount}
            inStock={product.inStock}
            qty_instock={product.qty_instock}
            originalPrice={product.originalPrice}
            tag={product.tag}
            isNew={product.isNew}
          />
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="no-products">
          <p>No featured products found in {selectedFilter} category.</p>
        </div>
      )}
    </div>
  );
};

export default FeaturedProducts;
